module.exports = __webpack_public_path__ + "static/media/ID_Card_Verify.101189cd.svg";